import { MESSAGES } from '@guuru/chat-common';
import { appendLocalMessage, ChatAPI, setChatLoading } from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delay as sleep } from '@guuru/helpers-common';

const requestPartnerSelection = 'bot:::requestPartnerSelection';

const addBotRequestPartnerSelection = (partners, delay = true) =>
  sleep(delay ? ChatAPI.getBotEllipsisMessageDelay() : 0).then(() => {
    const message = ChatAPI.messages.createBotMessage(
      Date.now(),
      requestPartnerSelection,
      MESSAGES.partnerSelection,
      { partners },
      true,
      false,
    );
    return message;
  });

const organizationSelection = {
  validate() {
    return true;
  },

  async render(_, { action }) {
    const locale = ChatAPI.storeRetrieveLocale();
    const { organization: { partners } = {} } = await ChatAPI.getChatSettings(
      action.partnerId,
      locale,
    );
    events.requestPartnerSelection(locale, action.partnerId);
    const partnerSelection = await addBotRequestPartnerSelection(partners);
    appendLocalMessage(partnerSelection);
    setChatLoading(false);
    return { goToNextStep: false };
  },
};

export default organizationSelection;
